<div class="divider-container">
  <mat-divider class="divider"></mat-divider>
</div>
